import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Section } from '../../models/section';
import { SectionService } from '../../services/section.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { ActService } from '../../services/act.service';
import { Act } from '../../models/act';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.css']
})
export class SectionComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerSection: PageHeader;
  entity: Section = new Section();
  selectedSection: Section = new Section();
  editingEntity: Section = new Section();
  sections: any;
  sectionColumns: any[]=[];
  listView: boolean = true;
  formCaption: string = '';
  act: Array<Act> = [];
  selectedAct: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  opened: boolean = false;
  details: any;
  constructor(
    private _sectionService: SectionService,
    private _actService: ActService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerSection = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));

    this.sections = [];
    this.getAllSection();
  }
  ngAfterViewInit(): void {
  
    this.sectionColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, width: 70, sortable: true },
      { field: "SectionName", title: 'Section', filter: true, width: 150, sortable: true },
      { field: "ActName", title: 'Act', filter: true, width: 200, sortable: true },
      { field: "Active", title: 'Active', filter: false, width: 100, sortable: true }, 
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }  
    ];

 
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._sectionService.getAllSections('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<Section>) => {
      this.sections = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }
  getAllAct(filter: string) {
    this._actService.getAllAct(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Act>) => {
      this.act = data;
    })
  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._sectionService.getAllSections(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((sections: Array<Section>) => {
        this.sections = {
          data: sections,
          total: sections[0] ? sections[0].TotalCount : 0
        }
      });
    }
  }
  getAllSection() {
    this._sectionService.getAllSections('', Number(this.defaultPageSize), 1, 0, 0).subscribe((sections: Array<Section>) => {
      this.sections = {
        data: sections,
        total: sections[0] ? sections[0].TotalCount : 0
      }
    })
  };

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._sectionService.deleteSection(this.selectedSection.Section_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearSection();
            this.getAllSection();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerSection = new PageHeader();
    headerSection.PageCaption = "Section";
    headerSection.IconClass = "bi bi-shield-shaded";
    return headerSection;
  }

  deleteSection(event: any) {
    if (event.seletedRows[0]) {
      this.selectedSection.Section_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Section",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addSection(event: any) {
    this.listView = false;
    this.clearSection();
    this.getAllAct('');
    this.formCaption = "Add Section";
  }

  editSection(event: any): void {
    if (event.seletedRows[0]) {
      this._sectionService.viewSection(event.seletedRows[0]).subscribe((sections: Array<Section>) => {
        let editEnity = sections[0] ? sections[0] : new Section();
        if (editEnity) {
          this.editingEntity = editEnity;
          this.selectedAct = { Act_Id: editEnity.Act_Id, ActName: editEnity.ActName };
          this.entity = { ...this.editingEntity }; 
          this.listView = false;
          this.formCaption = "Edit Section";
          this.getAllAct('');
          this.entity.EntityMetaData = [
            { FieldName: 'SectionName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Section Name is required' },
            //{ FieldName: 'Act_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Act is required' },
          ];
        }
      });
    }
  }

  save(event: any): void {
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._sectionService.checkDuplication(this.entity.SectionName, this.entity.Section_Id).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('Section already exists');
          this.saveDisabled = false;
        }
        else { 
          this._sectionService.saveSection(this.entity).subscribe(() => {
            if (this.entity.Section_Id == '00000000-0000-0000-0000-000000000000') {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearSection();
            this.getAllSection();
          });
        }
      });
    }
    else {
      this.saveDisabled = false;
    }
  }
  goToBackTab(): void {
    this.listView=true;
  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }

  gotoBack(): void {
    this.listView = true;
    this.getAllSection();
  }

  refreshSections(event: any): void {
    this.sections = [];
    this.getAllSection();
  }

  clearSection(): void {
    this.selectedAct = {};
    this.entity = new Section();
    this.saveDisabled = false;
  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.Section_Id = dataItem.Section_Id;
    this.details = [];
    this._sectionService.viewSection(this.entity.Section_Id).subscribe((sections: Array<Section>) => {
      this.opened = true;
      this.details = sections[0];
    })}
}
